import apiClient from '@/api/apiClient.js';
import { getInstProfesId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    catEventType: [],
    events: [],
    dataWeeklyPattern: {},
    localsEvents: [],
    status: '',
    dataNamePatient: '',
  },

  getters: {
    schema(state) {
      return state.schema;
    },
    catEventType(state) {
      return state.catEventType;
    },
    status(state) {
      return state.status;
    },
    dataNamePatient(state) {
      return state.dataNamePatient;
    },
    events(state) {
      return state.events;
    },
    dataWeeklyPattern(state) {
      return state.dataWeeklyPattern;
    },
    localsEvents(state) {
      return state.localsEvents;
    },
  },

  mutations: {
    insertSchema(state, payload) {
      state.schema = payload?.schema;
      state.catEventType = Array.isArray(payload?.catEventType)
        ? payload.catEventType
        : [];
    },
    insertEvents(state, recordsData) {
      state.events = Array.isArray(recordsData?.dbEvents) ? recordsData.dbEvents : [];
      state.dataWeeklyPattern = typeof recordsData?.dataWeeklyPattern === 'object' ? recordsData.dataWeeklyPattern : {};
      state.localsEvents = Array.isArray(recordsData?.localsEvents) ? recordsData.localsEvents : [];
    },
    pinSuccess(state, dataPat) {
      state.status = dataPat.pinMatch;
      state.dataNamePatient = dataPat.dataNamePatient;
    },
    pinError(state) {
      state.status = false;
    },
    updatePatternSuccess(state) {
      state.status = 'loaded';
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
    SET_STATUS_ERROR(state) {
      state.status = 'error';
    },
    SET_STATUS_NOT_ID(state) {
      state.status = 'errorNotID';
    },
  },

  actions: {
    async loadSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const res = await apiClient.proAppointmentsASchema();
        const schema = res.data;

        const res2 = await apiClient.catEventType();
        const catEventType = res2.data.data;
        commit('insertSchema', {schema, catEventType});
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
    async loadEvents({ commit }, dateFocus) {
      try {
        const id = getInstProfesId();

        if (!id) {
          return;
        }

        if (!dateFocus) {
          return;
        }

        const res = await apiClient.modelProAppointmentsA(id, dateFocus);

        const recordsData = res?.data?.data || [];

        commit('insertEvents', recordsData);
        commit('SET_STATUS', 'loaded');
      } catch (e) {
        console.error(e);
        commit('SET_STATUS', 'error');
      }
    },
    async verifPat({ commit }, model) {
      try {
        const id = getInstProfesId();
        const res = await apiClient.verifProAppointmentsA(id, model);
        const pinMatch = res.data.data.pinMatch;

        let dataNamePatient;
        if (pinMatch === true) {
          dataNamePatient = res.data.data.namePatient;
        }

        let dataPat = { pinMatch, dataNamePatient };
        commit('pinSuccess', dataPat);
      } catch (e) {
        console.error(e);
        commit('pinError');
      }
    },
    async updateWeeklyPattern({ commit }, payload) {
      try {
        commit('SET_STATUS', 'update');
        const instProfesId = getInstProfesId();
        const res = await apiClient.updateProWeeklyPattern(instProfesId, payload);

        if (res.status === 200) {
          commit('SET_STATUS', 'loaded');
        }        
      } catch (e) {
        console.error(e);
        commit('SET_STATUS_ERROR');
      }
    },
    async saveEvents({ commit }, model) {
      try {        
        commit('SET_STATUS', 'create');
        model.instProfesId = getInstProfesId();
        await apiClient.createProAppointmentsA(model);

        setTimeout(() => {
        }, 8000);

        commit('SET_STATUS', 'loaded');
      } catch (e) {
        console.error(e);
        commit('SET_STATUS_ERROR');
      }
    },
    async updateEvents({ commit }, payload) {
      try {
        commit('SET_STATUS', 'update');
        const id = payload.id;
        const model = payload.model;
        await apiClient.updateProAppointmentsA(id, model);

        commit('SET_STATUS', 'loaded');
      } catch (e) {
        console.error(e);
        commit('SET_STATUS_ERROR');
      }
    },
    async delEvents({ commit }, payload) {
      try {
        commit('SET_STATUS', 'remove');
        const id = payload.id;

        if (id) {
          await apiClient.deleteProAppointmentsA(id);

          setTimeout(() => {
            commit('SET_STATUS', 'loaded');
          }, 11000);
        }

        commit('SET_STATUS_NOT_ID');
      } catch (e) {
        console.error(e);
        commit('SET_STATUS_ERROR');
      }
    },
  },
};
